import useShopifyCollection from "@hooks/useShopifyCollection"
import {
  checkProductDisplayFlags,
  getShopifyProductWithContentfulData,
  getProductsFlagsVisibilityState,
} from "@lib/shopify"
import { ContentfulProductWithShopifyData, ShopifyCollection } from "@lib/types"
import { useRouter } from "next/router"
import React, { useEffect, useState } from "react"
import ContentLoader, { List } from "react-content-loader"
import styled from "styled-components"
import { ProductPage } from "."

const ProductPageWrapper = ({ page, reviewData }: any) => {
  const [readyToShow, setReadyToShow] = useState(false)
  const [hideFromCollections, setHideFromCollections] = useState(false)
  const [family, setFamily] = useState<any>(null)
  const [showLoader, setShowLoader] = useState(false)
  const { locale } = useRouter()
  const router = useRouter()

  useEffect(() => {
    const checkProductFlags = async () => {
      const data = await getShopifyProductWithContentfulData(page.slug, locale)
      console.log(page)
      //console.log(delete data.contentfulData)
      const hasContentfulData = !!data.contentfulData
      console.log({ hasContentfulData })
      const contentfulData = hasContentfulData ? JSON.parse(data.contentfulData.value) : page
      console.log(contentfulData)
      const { hideFromSite, hideFromCollections } = contentfulData
      if (hideFromSite) {
        router.push("/")
      } else {
        setReadyToShow(true)
      }
      if (hasContentfulData) {
        if (!contentfulData.productFamily) {
          setFamily([])
        } else {
          const slugArray = contentfulData.productFamily.productsCollection.items.map(
            (product: any) => product.slug
          )
          const FamilyWithVisibilityFlags = await getProductsFlagsVisibilityState(slugArray, locale)
          setFamily(FamilyWithVisibilityFlags)
          //console.log("Family With Flags", FamilyWithVisibilityFlags)
        }
      } else {
        if (!page.productFamily) {
          setFamily([])
        } else {
          setFamily(page.productFamily?.productsCollection?.items)
        }
      }
      setHideFromCollections(hideFromCollections)
    }
    checkProductFlags()
  }, [page])

  useEffect(() => {
    setTimeout(() => setShowLoader(true), 400)
  }, [])

  const backgroundColor = "#f9f7f5"
  const foregroundColor = "#f5f1ef"

  /*  const backgroundColor = "#f5f0f0"
  const foregroundColor = "#f0e8e3" */

  return (
    <>
      {readyToShow ? (
        <ProductPage
          page={page}
          family={family}
          reviewData={reviewData}
          hideFromCollections={hideFromCollections}
        />
      ) : (
        <WhitePlaceholder>
          {showLoader && (
            <>
              <WrapperDesktop>
                <ImagesLoaderWrapper>
                  <ImagesLoaderContainer>
                    {new Array(6).fill(0).map((_, index) => (
                      <ImageLoaderContainer key={index}>
                        <ContentLoader
                          viewBox="0 0 373 560"
                          backgroundColor={backgroundColor}
                          foregroundColor={foregroundColor}
                        >
                          <rect x="0" y="0" rx="4" ry="4" width="373" height="560" />
                        </ContentLoader>
                      </ImageLoaderContainer>
                    ))}
                  </ImagesLoaderContainer>
                </ImagesLoaderWrapper>
                <ProductInfoLoaderContainer>
                  <ContentLoader
                    viewBox="0 0 373 900"
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="30" y="30" rx="4" ry="4" width="320" height="40" />
                    <rect x="30" y="85" rx="4" ry="4" width="320" height="17" />
                    <rect x="30" y="140" rx="4" ry="4" width="320" height="110" />
                    <rect x="30" y="270" rx="4" ry="4" width="320" height="30" />
                    <rect x="30" y="330" rx="4" ry="4" width="250" height="200" />
                  </ContentLoader>
                </ProductInfoLoaderContainer>
              </WrapperDesktop>
              <WrapperMobile>
                <ContentLoader
                  viewBox="0 0 373 1000"
                  backgroundColor={backgroundColor}
                  foregroundColor={foregroundColor}
                >
                  <rect x="0" y="0" rx="4" ry="4" width="373" height="560" />
                  <rect x="15" y="580" rx="4" ry="4" width="200" height="15" />
                  <rect x="15" y="600" rx="4" ry="4" width="340" height="40" />
                  <rect x="15" y="650" rx="4" ry="4" width="340" height="20" />
                  <rect x="15" y="700" rx="4" ry="4" width="340" height="160" />
                </ContentLoader>
              </WrapperMobile>
            </>
          )}
        </WhitePlaceholder>
      )}
    </>
  )
}

const WhitePlaceholder = styled.div`
  min-height: 100vh;
`

const WrapperMobile = styled.div`
  height: 100vh;
  @media (min-width: ${({ theme }) => theme.breakpoint.md}px) {
    display: none;
  }
`

const WrapperDesktop = styled.div`
  display: none;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  height: 200rem;
  max-width: 160rem;
  margin: auto;
  @media (min-width: ${({ theme }) => theme.breakpoint.md}px) {
    display: flex;
  }
`

const ImagesLoaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 55%;
  margin-top: 2.5rem;
  max-width: 75rem;
`

const ImagesLoaderContainer = styled.div`
  height: 100rem;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 2rem;
  @media (min-width: ${({ theme }) => theme.breakpoint.md}px) {
    padding: 0 0 0 5rem;
  }
  @media (min-width: ${({ theme }) => theme.breakpoint.xl}px) {
    padding: 0 0 0 0;
  }
`

const ImageLoaderContainer = styled.div`
  width: 100%;
  height: 100%;
`

const ProductInfoLoaderContainer = styled.div`
  width: 45%;
  max-width: 55rem;
`

export default ProductPageWrapper
